import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-details-claim',
  templateUrl: './details-claim.component.html',
  styleUrls: ['./details-claim.component.css']
})
export class DetailsClaimComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
